// src/components/Events/AICIS2024.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Events.css';

const AICIS2024 = () => {
  return (
    <div className="event-detail-page">
      {/* Hero Section */}
      <div className="event-detail-hero">
        <div className="event-detail-hero-overlay"></div>
        <div className="event-detail-hero-content">
          <span className="event-detail-badge">Past Event Retrospective</span>
          <h1>AICIS 2024</h1>
          <h2>Inaugural Africa Infrastructure, Climate Change, Security & Green Investment Summit</h2>
          
          <div className="event-detail-meta">
            <div className="meta-item">
              <span className="meta-icon">📅</span>
              <span>October 2024</span>
            </div>
            <span className="meta-divider">|</span>
            <div className="meta-item">
              <span className="meta-icon">📍</span>
              <span>Washington D.C., USA</span>
            </div>
            <span className="meta-divider">|</span>
            <div className="meta-item">
              <span className="meta-icon">👥</span>
              <span>1,200+ Attendees</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Container */}
      <div className="event-detail-container">
        {/* Overview Section */}
        <div className="detail-section">
          <div className="section-header">
            <span className="section-badge">Washington D.C.</span>
            <h2>Summit Highlights & Outcomes</h2>
            <div className="section-line"></div>
          </div>
          <p className="overview-text">
            The inaugural <strong>AICIS 2024 Summit</strong> convened in Washington D.C., establishing a critical bridge between African project developers, policymakers, and North American capital. The event focused on mobilizing international private capital and fostering transatlantic partnerships for green growth.
          </p>
          <p className="overview-text">
            Deliberations centered on policy alignment, project readiness, and innovative financial structuring to derisk investments in Africa's infrastructure.
          </p>

          <div className="overview-highlights">
            <div className="highlight-item">
              <span className="highlight-number">1,200+</span>
              <span className="highlight-label">Participants</span>
              <span className="highlight-value">Global Leaders</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-number">$1.5B+</span>
              <span className="highlight-label">Commitments</span>
              <span className="highlight-value">Investment Pledges</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-number">25+</span>
              <span className="highlight-label">Panel Sessions</span>
              <span className="highlight-value">Expert Dialogues</span>
            </div>
          </div>
        </div>

        {/* Sessions Section */}
        <div className="detail-section">
          <div className="section-header">
            <span className="section-badge">Sessions</span>
            <h2>Key Panel Discussions</h2>
            <div className="section-line"></div>
          </div>

          <div className="sessions-grid">
            <div className="session-card">
              <span className="session-icon">🔌</span>
              <h3>Funding Africa's Clean Grid</h3>
              <p>Exploring public-private partnerships (PPPs) for scaling solar, wind, and geothermal grid connections across Sub-Saharan Africa.</p>
            </div>

            <div className="session-card">
              <span className="session-icon">🛡️</span>
              <h3>Securing Resource Corridors</h3>
              <p>Addressing physical and cybersecurity challenges affecting key critical minerals and green energy transmission infrastructure.</p>
            </div>

            <div className="session-card">
              <span className="session-icon">📈</span>
              <h3>Derisking Green Investments</h3>
              <p>Melt-down of institutional barriers and using multilateral guarantees to make green projects bankable for foreign investors.</p>
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div className="detail-back">
          <Link to="/events" className="back-button">
            ← Back to Events
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AICIS2024;
